import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/lottery",
    name: "lottery",
    meta: {
      title: "抢免费剪发券咯~"
    },
    component: () => import("../views/lottery.vue")
  },
  {
    path: "/delivery",
    name: "delivery",
    meta: {
      title: "奖品收货信息"
    },
    component: () => import("../views/delivery.vue")
  }
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  const { title } = to.meta;
  window.document.title = title;
  next();
});

export default router;
